import { MapLogo } from '../../icons/MapLogo'
import { NewCheckBoxButton } from '../NewCheckBoxButton/NewCheckBoxButton'
import NewInputRange from '../NewInputRange/NewInputRange'
import styles from './NewRoomsFilter.module.scss'
import { NewRoomsFilterTypes } from './NewRoomsFiltertypes'

export const NewRoomsFilter = ({
  map,
  toggleMap,
  roomsChange,
  setRangeValue,
}: NewRoomsFilterTypes) => {
  return (
    <div className={styles.buttons}>
      <div className={styles.rooms}>
        <NewCheckBoxButton
          label='Студия'
          value='studio'
          onChange={roomsChange}
          classes={['text']}
        />
        <NewCheckBoxButton label='1' value='1' onChange={roomsChange} />
        <NewCheckBoxButton label='2' value='2' onChange={roomsChange} />
        <NewCheckBoxButton label='3+' value='more' onChange={roomsChange} />
      </div>
      <NewInputRange
        rangeValue={['4202668', '49524980']}
        classModifiers={['width375']}
        onChange={(values: number[] | number) => {
          if (Array.isArray(values)) {
            setRangeValue(values)
          }
        }}
      />
      {/* <RangePicker setRangeValue={setRangeValue} rangeValue={rangeValue} /> */}
      <div className={styles.toggle}>
        <button onClick={toggleMap}>
          {!map ? (
            <>
              На карте
              <MapLogo />
            </>
          ) : (
            'Списком'
          )}
        </button>
      </div>
    </div>
  )
}
